var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.041,
    height: 54.041,
    viewBox: "0 0 54.041 54.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.338,1.167l-.068.158-6.53,15.154H4.323A11.067,11.067,0,0,0,0,17.356L3.94,7.944l.09-.225.158-.36a1.948,1.948,0,0,1,.158-.383C7.3.153,10.628-1.4,17.338,1.167Z",
    transform: "translate(11.168 4.503)",
    fill: "none",
    stroke: "#11a377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18.734,15.762a10.718,10.718,0,0,0-3.175-.45H0L6.53.158,6.6,0c.338.113.653.27.991.405L12.564,2.5c2.77,1.148,4.706,2.342,5.877,3.783A4.763,4.763,0,0,1,19,7.093a3.426,3.426,0,0,1,.45.968,3.635,3.635,0,0,1,.2.585C20.265,10.538,19.9,12.857,18.734,15.762Z",
    transform: "translate(21.909 5.67)",
    fill: "none",
    stroke: "#11a377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M43.93,10.988v4.391c0,.45-.023.9-.045,1.351-.428,7.858-4.819,11.821-13.15,11.821H13.172a12.427,12.427,0,0,1-1.6-.113Q.833,27.73.113,16.978A12.427,12.427,0,0,1,0,15.379V10.988A11.019,11.019,0,0,1,6.665.878,11.151,11.151,0,0,1,10.988,0H32.965A11.269,11.269,0,0,1,36.14.45,11.041,11.041,0,0,1,43.93,10.988Z",
    transform: "translate(4.53 20.982)",
    fill: "none",
    stroke: "#11a377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M10.605,0,6.665,9.412A11.019,11.019,0,0,0,0,19.522v-6.6A13.169,13.169,0,0,1,10.605,0Z",
    transform: "translate(4.503 12.448)",
    fill: "none",
    stroke: "#11a377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M7.791,11.641v6.6A10.985,10.985,0,0,0,0,7.723C1.171,4.8,1.509,2.5.946.585A2.572,2.572,0,0,0,.743,0,13.111,13.111,0,0,1,7.791,11.641Z",
    transform: "translate(40.662 13.73)",
    fill: "none",
    stroke: "#11a377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H54.041V54.041H0Z",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.271eeec95b2008ffe2d12729cb213442.svg";
export { ForwardRef as ReactComponent };